import { API, graphqlOperation } from 'aws-amplify';
import * as queries from "@app/data/graphql/queries";

export async function getCustomerProducts (variables) {
    let resp;
    try {
        resp = await API.graphql(
            graphqlOperation(queries.getCustomerProducts, variables)
        );
       
        if (resp.data.getCustomerProducts.code === 200) {
        } else {
            throw new Error(resp.data.getCustomerProducts.message);
        }
    } catch (error) {
        console.log(error);
    }
    return resp;
}